import type { ClientAPICall } from '@/app/components/search/common/clientApiType.ts';
import { API_CALL_PREFIX } from '@/app/components/search/utils/api/apiUtils.ts';
import { v4 as uuidv4 } from 'uuid';
import {
  HEADER_NAME_APP_NAME,
  HEADER_NAME_HOST_ID,
  HEADER_NAME_MPT,
  HEADER_NAME_SPAN_ID,
  HEADER_NAME_TRACE_ID,
} from '@lmn/nextjs-appfw/dist/common';
import { APP_NAME } from '@/utils/appUtils.ts';
import { TSX_REQUEST_HEADER_NAME } from '@/app/pageTypes.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { fetchWithRetryTimeout } from '../utils/fetchClient.ts';

const createHeadersClientAPICall = (
  headers: { [key: string]: string },
  traceParent: string,
  commonData: CommonData
) => {
  const traceId = uuidv4();
  const tracingHeaders = {
    [HEADER_NAME_TRACE_ID]: traceId,
    [HEADER_NAME_APP_NAME]: APP_NAME,
    [HEADER_NAME_SPAN_ID]: '0000000',
    [HEADER_NAME_HOST_ID]: 'browser',
  };
  const traceParentHeader = traceParent ? { [TSX_REQUEST_HEADER_NAME.TRACE_PARENT]: traceParent } : undefined;
  const mptHeader = commonData.mpt ? { [HEADER_NAME_MPT]: commonData.mpt } : undefined;
  const csrfTokenHeader = commonData.csrfToken
    ? { [TSX_REQUEST_HEADER_NAME.CSRF_TOKEN]: commonData.csrfToken }
    : undefined;
  return { ...headers, ...tracingHeaders, ...traceParentHeader, ...mptHeader, ...csrfTokenHeader };
};

const clientAPICall = async <ReqPayload, Res>({
  apiName,
  payload,
  defaultResponse,
  headers = {},
  traceParent,
  commonData,
}: ClientAPICall<ReqPayload, Res>): Promise<Res> => {
  const url = `${API_CALL_PREFIX}${apiName}`;
  let response = defaultResponse || ({} as Res);

  try {
    const headersClientAPICall = createHeadersClientAPICall(headers, traceParent, commonData);
    response = await fetchWithRetryTimeout<Res>({
      url,
      body: JSON.stringify(payload),
      headers: headersClientAPICall,
      timeout: 20000,
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // TODO: decouple from clientAppLog
    // clientAppLog({
    //   level: 'WARN',
    //   codeSourceName: 'clientAPICall',
    //   logMessage: `apiName:${apiName}, payload:${JSON.stringify(payload)}, error: ${error.toString()}`,
    //   url,
    // });
  }

  return response;
};

export default clientAPICall;
